export default {"src":"/_next/static/media/search.a7e8737f.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};